import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=54baae00&"
import script from "./PopUp.vue?vue&type=script&lang=ts&"
export * from "./PopUp.vue?vue&type=script&lang=ts&"
import style0 from "./PopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports